import React, { useState } from 'react';
import { __ } from '../../Lang.js';

// Laravel-injected via window.__INITIAL_FAQS__ from controller/blade
const faqs = (window.__INITIAL_FAQS__ || []).slice(0, 5);

const GuestFAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggle = (idx) => {
    setOpenIndex(openIndex === idx ? null : idx);
  };

  return (
    <section className="content-section-3 soul-faqs">
      <div className="container">
        <div className="row">
          <h2 className="faq-section-title">
            THAT WHICH IS - {__('Frequently Asked Questions')}
          </h2>

          {faqs.map((item, idx) => (
            <details className="faq-block" key={idx} open={openIndex === idx}>
              <summary className="faq-title" onClick={() => toggle(idx)}>
                {item.question}
                <span className="faq-icon">{openIndex === idx ? '▴' : '▾'}</span>
              </summary>
              <div
                className="faq-answer"
                dangerouslySetInnerHTML={{ __html: item.answer }}
              />
            </details>
          ))}
        </div>
      </div>
    </section>
  );
};

export default GuestFAQ;